module.exports = __webpack_public_path__ + "img/stapel-02.ccdaf972.svg";